// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_oF2Lt {
  background-color: var(--_00000020-background);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.CreateParameterPopup_c2BBQ {
  height: 100%;
  width: 100%;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}

.CreateParameterPopupContent_jTRlZ {
  width: 100%;
  height: 100%;
  max-width: 700px;
  max-height: 400px;
  box-sizing: border-box;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  background-color: var(--f5-background);
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 5;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);

  .contentContiner_IJO8f {
    height: calc(100% - 60px);
    display: flex;
    gap: 6px;
    background-color: var(--f5-background);
    padding: 4px;

    .contentParameter_Ut9DT {
      margin: 0 auto;
      width: 90%;
      background-color: var(--white-background);
      padding: 12px;
      gap: 20px;
      display: flex;
      flex-direction: column;
      border-radius: 14px;
      -webkit-border-radius: 14px;
      /* height: calc(100vh - 140px); */
      height: 100%;
      overflow-y: scroll;

      .textContent_W0faP {
        margin: 0px 0px 10px;
      }


      .unitMeasure_gv2iG {
        display: flex;
        align-items: center;
        gap: 10px;
        >div{
          flex: 1 1 !important;
          box-sizing: border-box;
        }
      }
      input,
      textarea {
        border: none;
        outline: none;
        font-size: 14px;
        font-weight: 400;
        color: var(--_75-color);
        min-height: 21px !important;
        background-color: var(--f4-background);
        border-radius: 5px;
        font-family: "Inter", sans-serif;
        box-sizing: border-box;
        width: 100%;
        field-sizing: content;
        padding: 8px 4px;
        resize: none;
        &::placeholder{
          font-weight: 400;
          color: var(--_75-color);
          font-size: 13px;
          font-family: "Inter", sans-serif;
        }
      }
      textarea {
        min-height: 100px !important;
        max-height: 200px;
      }
    }
  }
}

.leftSide_vl7xj{
  height: 100%;
  max-width: 300px;
  min-width: 160px;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar{
    display: none;
  }
}

.categoryParameter_I4dmC{
  
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  .rightSideCategoryParameter_QCDdh{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    .row_pnSrH{
      display: flex;
      align-items: center;
      gap: 10px;
    }

  }
}

.numberComponent_nxCxX{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rightSideType_muB9d{
  display: flex;
  flex-direction: column;
  align-items: end;
}

.numberComponentColumn_jfbOT{
  flex-direction: column;
  p{
    width: 100%;
    text-align: start;
  }
  >div{
    width: 100%;
    textarea{
      width: 100%;
    }
  }
}
.amountContainer_btk60,.discountContainer_SG7W1{
  display: flex;
  align-items: center;
  gap: 10px;
  width: 30%;
}
.dateContainer_hMAij{
  display: flex;
  align-items: center;
  background-color: var(--f4-background);
  padding: 0 4px;
  border-radius: 4px;
  svg{
    color: #4F5660;
    height: 20px;
    width: 20px;
  }
}
.discountContainer_SG7W1{
  width: fit-content;
}

.selectCurrencyBtn_FE4O4{
 color: var(--_264f88-color); 
 text-decoration: underline;
 cursor: pointer;
 display: flex;
 align-items: center;
 gap: 5px;
 text-wrap: nowrap;
}

.chevronIcon__Bdpx {
  margin-top: 1px;
  margin-left: auto;
  color: var(--_71717a-color);
}

.bgCurrency_DK_Ts {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: var(--_00000033-background);
  z-index: 5;
}

.newCurrencyPopup_vfNw6 {
  position: fixed;
  background-color: var(--white-background);
  padding: 10px;
  top: 50%;
  left: 50%;
  z-index: 6;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 70vh;
  overflow-y: scroll;

  .dropdownOption_B8mYT {
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    color: var(--_9c9d9f-color);
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    transition: background-color 0.2s;
    -webkit-transition: background-color 0.2s;
    -moz-transition: background-color 0.2s;
    -ms-transition: background-color 0.2s;
    -o-transition: background-color 0.2s;

    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.discountTypeButtons_lX44y{
  display: flex;
  align-items: center;
   >button{
    background-color: transparent;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    color: var(--_6-color);
    border-radius: 4px;
    span{
      background-color: var(--white-background);
      padding: 4px;
    }
  }
  .activeButton_ZIr2C{
    background-color: var(--f4-background);
  }
}
.dateRanges_crDDL{
  display: flex;
  align-items: center;
  gap: 10px;
}

.filesContainer_YGx0m{
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  >div{
    display: flex;
    align-items: center;
    gap: 5px;
  }
}

.SortableItemList_wYfqJ{
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  .GrabIconContainer_XuJrK{
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
    input{
      width: 100%;
    }
    svg{
      height: 20px;
      min-width: 20px;
    }
  }
}

.categoriesContainer_EWMp1{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.listItemContainer_OvM8v{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.valuesContent_zzw0M{
  display: flex;
  align-items: center;
}

.ColorListItem_v7S7e{
  margin: 5px 0px;
  display: flex;
  align-items: center;
  gap: 5px ;
  >div{
    display: flex;
    align-items: center;
    gap: 5px;
  }
}


.tagsContainer_J3raB{
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: auto;

  .tag_F5Ev1{
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    span{
      /* width: 100%; */
      padding: 10px 20px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
}
.circle_pACdz{
  height: 15px;
  min-width: 15px;
  width: 15px;
  border-radius: 999px;
}


.actionsTag_m14LW{
  display: flex;
  align-items: center;
  gap: 10px;
}
.dropdownContainer_aFmBv{
  width: 100%;
  display: flex;
  justify-content: end;
  margin: 10px 0;
}

.statusContent_k5zIT{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.infoStatus_evGxL{
  display: flex;
  align-items: center;
  gap: 5px;
  input{
    width: 200px !important;
  }
  svg{
    height: 15px;
    width: 15px;
    min-width: 15px;
  }
}
.paid_RIqDr{
background-color: rgb(0, 159, 122);
}


.statusPopup_lOGBB {
  position: absolute;
  top: 100%;
  left: -12px;
  background: #2C2C2C;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 12px 8px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 10px;
  >div{
    border: 2px solid transparent;
  }
  
.statusOptionSelected_DSixX{
  border: 2px solid white;
}
}
/* Triángulo apuntando hacia arriba */
.statusPopup_lOGBB::before {
  content: "";
  position: absolute;
  top: -6px; /* justo encima del popup */
  left: 12px; /* ajústalo según donde quieras la punta */
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #2C2C2C; /* mismo color del fondo */
}


.checklistItem_XD3O_{
  display: flex;
  align-items: center;
  justify-content: space-between;
  input{
    width: fit-content;
  }
  .checklistInfo_Ix7lV{
    display: flex;
    align-items: center;
    gap: 5px;
    input[type="checkbox"]{
      width: fit-content !important;
    }
    input[type="text"]{
      width: 400px !important;
    }
    svg{
      min-width: 15px;
      height: 15px;
      outline: none;
      cursor: grab;
    }
  }
}

.inputParameter_ft7Nd{
  width: 200px !important;
}

.inputContainer_miM1Q {
  display: flex;
  width: 100%;
  align-items: center;
  background-color: var(--f4-background);
  width: 300px;
  padding: 0 8px; 
  input::placeholder {
    color: var(--_71717a-color);
  }
}
.inputContainer_miM1Q {
  /* padding: 5px; */
  position:relative;
  box-sizing: border-box;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  resize: none;
  .searchContactInput_TufCi {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
    width: 100%;
    border-radius: 8px;
    padding: 6px;
    border: none;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    background-color: var(--f4-background);
    outline: none;
  }
}


.contactContent_QpBRr{
  display: flex;
  align-items: center;
  justify-content: space-between;
  >div{
    display: flex;
    align-items: center;
    gap: 10px;
  }
  img{
    min-width: 20px;
    height: 20px;
    border-radius: 999px;
  }

  .contactInfo_wOhUM{
    display: flex;
    flex-direction: column;
    p{
      margin: 0;
      color: #09090B;
      font-size: 16px;
    }
    span{
      color: #666666;
      font-size: 13px;
    }
    >div{
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
}
.chevronIcon__Bdpx {
  margin-top: 1px;
  margin-left: auto;
  color: var(--_292d32-color);
}


.urlContainer_XpqoW{
  display: flex;
  align-items: center;
  gap: 5px;
}



.formulaContainer_JFBX6{
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  p{
    margin: 0;
  }
  span{
    color: #717171;
    font-size: 13px;
  }
  input{
    width: 100%;
  }
}



.assessmentContainer_VJCwp{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .assessmentContent_gGfmU{
    display: flex;
    align-items: center;
    gap: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CreateParameterPopup/CreateParameterPopup.module.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,YAAY;EACZ,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;AACT;AACA;EACE,YAAY;EACZ,WAAW;;EAEX,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;;EAEnC;IACE,yBAAyB;IACzB,aAAa;IACb,QAAQ;IACR,sCAAsC;IACtC,YAAY;;IAEZ;MACE,cAAc;MACd,UAAU;MACV,yCAAyC;MACzC,aAAa;MACb,SAAS;MACT,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,2BAA2B;MAC3B,iCAAiC;MACjC,YAAY;MACZ,kBAAkB;;MAElB;QACE,oBAAoB;MACtB;;;MAGA;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT;UACE,oBAAkB;UAClB,sBAAsB;QACxB;MACF;MACA;;QAEE,YAAY;QACZ,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,2BAA2B;QAC3B,sCAAsC;QACtC,kBAAkB;QAClB,gCAAgC;QAChC,sBAAsB;QACtB,WAAW;QACX,qBAAqB;QACrB,gBAAgB;QAChB,YAAY;QACZ;UACE,gBAAgB;UAChB,uBAAuB;UACvB,eAAe;UACf,gCAAgC;QAClC;MACF;MACA;QACE,4BAA4B;QAC5B,iBAAiB;MACnB;IACF;EACF;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;;EAEF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,WAAW;IACX;MACE,WAAW;IACb;EACF;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB;IACE,cAAc;IACd,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,kBAAkB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,0BAA0B;CAC1B,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,iBAAiB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,MAAM;EACN,OAAO;EACP,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iCAAiC;IACjC,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;;IAEpC;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;GAClB;IACC,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB;MACE,yCAAyC;MACzC,YAAY;IACd;EACF;EACA;IACE,sCAAsC;EACxC;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX;MACE,WAAW;IACb;IACA;MACE,YAAY;MACZ,eAAe;IACjB;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;;EAEpB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B;MACE,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;MACnB,QAAQ;IACV;EACF;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF;AACA;AACA,kCAAkC;AAClC;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,6BAA6B;EAC/B;;AAEF;EACE,uBAAuB;AACzB;AACA;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,2BAA2B;EACtC,UAAU,EAAE,0CAA0C;EACtD,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC,EAAE,0BAA0B;AAC9D;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,6BAA6B;IAC/B;IACA;MACE,uBAAuB;IACzB;IACA;MACE,eAAe;MACf,YAAY;MACZ,aAAa;MACb,YAAY;IACd;EACF;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,cAAc;EACd;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,sCAAsC;IACtC,aAAa;EACf;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,eAAe;IACf,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB;MACE,SAAS;MACT,cAAc;MACd,eAAe;IACjB;IACA;MACE,cAAc;MACd,eAAe;IACjB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;IACV;EACF;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;;AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":[".bg {\n  background-color: var(--_00000020-background);\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n.CreateParameterPopup {\n  height: 100%;\n  width: 100%;\n\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 5;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n.CreateParameterPopupContent {\n  width: 100%;\n  height: 100%;\n  max-width: 700px;\n  max-height: 400px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  background-color: var(--f5-background);\n  overflow: hidden;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 5;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n\n  .contentContiner {\n    height: calc(100% - 60px);\n    display: flex;\n    gap: 6px;\n    background-color: var(--f5-background);\n    padding: 4px;\n\n    .contentParameter {\n      margin: 0 auto;\n      width: 90%;\n      background-color: var(--white-background);\n      padding: 12px;\n      gap: 20px;\n      display: flex;\n      flex-direction: column;\n      border-radius: 14px;\n      -webkit-border-radius: 14px;\n      /* height: calc(100vh - 140px); */\n      height: 100%;\n      overflow-y: scroll;\n\n      .textContent {\n        margin: 0px 0px 10px;\n      }\n\n\n      .unitMeasure {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        >div{\n          flex: 1 !important;\n          box-sizing: border-box;\n        }\n      }\n      input,\n      textarea {\n        border: none;\n        outline: none;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--_75-color);\n        min-height: 21px !important;\n        background-color: var(--f4-background);\n        border-radius: 5px;\n        font-family: \"Inter\", sans-serif;\n        box-sizing: border-box;\n        width: 100%;\n        field-sizing: content;\n        padding: 8px 4px;\n        resize: none;\n        &::placeholder{\n          font-weight: 400;\n          color: var(--_75-color);\n          font-size: 13px;\n          font-family: \"Inter\", sans-serif;\n        }\n      }\n      textarea {\n        min-height: 100px !important;\n        max-height: 200px;\n      }\n    }\n  }\n}\n\n.leftSide{\n  height: 100%;\n  max-width: 300px;\n  min-width: 160px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  &::-webkit-scrollbar{\n    display: none;\n  }\n}\n\n.categoryParameter{\n  \n  display: flex;\n  /* align-items: center; */\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: flex-start;\n  .rightSideCategoryParameter{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    .row{\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n\n  }\n}\n\n.numberComponent{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.rightSideType{\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n}\n\n.numberComponentColumn{\n  flex-direction: column;\n  p{\n    width: 100%;\n    text-align: start;\n  }\n  >div{\n    width: 100%;\n    textarea{\n      width: 100%;\n    }\n  }\n}\n.amountContainer,.discountContainer{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 30%;\n}\n.dateContainer{\n  display: flex;\n  align-items: center;\n  background-color: var(--f4-background);\n  padding: 0 4px;\n  border-radius: 4px;\n  svg{\n    color: #4F5660;\n    height: 20px;\n    width: 20px;\n  }\n}\n.discountContainer{\n  width: fit-content;\n}\n\n.selectCurrencyBtn{\n color: var(--_264f88-color); \n text-decoration: underline;\n cursor: pointer;\n display: flex;\n align-items: center;\n gap: 5px;\n text-wrap: nowrap;\n}\n\n.chevronIcon {\n  margin-top: 1px;\n  margin-left: auto;\n  color: var(--_71717a-color);\n}\n\n.bgCurrency {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background-color: var(--_00000033-background);\n  z-index: 5;\n}\n\n.newCurrencyPopup {\n  position: fixed;\n  background-color: var(--white-background);\n  padding: 10px;\n  top: 50%;\n  left: 50%;\n  z-index: 6;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 70vh;\n  overflow-y: scroll;\n\n  .dropdownOption {\n    padding: 8px 12px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--_9c9d9f-color);\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    -webkit-transition: background-color 0.2s;\n    -moz-transition: background-color 0.2s;\n    -ms-transition: background-color 0.2s;\n    -o-transition: background-color 0.2s;\n\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.discountTypeButtons{\n  display: flex;\n  align-items: center;\n   >button{\n    background-color: transparent;\n    outline: none;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    color: var(--_6-color);\n    border-radius: 4px;\n    span{\n      background-color: var(--white-background);\n      padding: 4px;\n    }\n  }\n  .activeButton{\n    background-color: var(--f4-background);\n  }\n}\n.dateRanges{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filesContainer{\n  margin: 10px 0px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  >div{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n.SortableItemList{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  \n  .GrabIconContainer{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    width: 100%;\n    input{\n      width: 100%;\n    }\n    svg{\n      height: 20px;\n      min-width: 20px;\n    }\n  }\n}\n\n.categoriesContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.listItemContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.valuesContent{\n  display: flex;\n  align-items: center;\n}\n\n.ColorListItem{\n  margin: 5px 0px;\n  display: flex;\n  align-items: center;\n  gap: 5px ;\n  >div{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n\n.tagsContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  pointer-events: auto;\n\n  .tag{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    justify-content: space-between;\n    span{\n      /* width: 100%; */\n      padding: 10px 20px;\n      border-radius: 10px;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n    }\n  }\n}\n.circle{\n  height: 15px;\n  min-width: 15px;\n  width: 15px;\n  border-radius: 999px;\n}\n\n\n.actionsTag{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.dropdownContainer{\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  margin: 10px 0;\n}\n\n.statusContent{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.infoStatus{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  input{\n    width: 200px !important;\n  }\n  svg{\n    height: 15px;\n    width: 15px;\n    min-width: 15px;\n  }\n}\n.paid{\nbackground-color: rgb(0, 159, 122);\n}\n\n\n.statusPopup {\n  position: absolute;\n  top: 100%;\n  left: -12px;\n  background: #2C2C2C;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 12px 8px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  >div{\n    border: 2px solid transparent;\n  }\n  \n.statusOptionSelected{\n  border: 2px solid white;\n}\n}\n/* Triángulo apuntando hacia arriba */\n.statusPopup::before {\n  content: \"\";\n  position: absolute;\n  top: -6px; /* justo encima del popup */\n  left: 12px; /* ajústalo según donde quieras la punta */\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #2C2C2C; /* mismo color del fondo */\n}\n\n\n.checklistItem{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  input{\n    width: fit-content;\n  }\n  .checklistInfo{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    input[type=\"checkbox\"]{\n      width: fit-content !important;\n    }\n    input[type=\"text\"]{\n      width: 400px !important;\n    }\n    svg{\n      min-width: 15px;\n      height: 15px;\n      outline: none;\n      cursor: grab;\n    }\n  }\n}\n\n.inputParameter{\n  width: 200px !important;\n}\n\n.inputContainer {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  background-color: var(--f4-background);\n  width: 300px;\n  padding: 0 8px; \n  input::placeholder {\n    color: var(--_71717a-color);\n  }\n}\n.inputContainer {\n  /* padding: 5px; */\n  position:relative;\n  box-sizing: border-box;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  resize: none;\n  .searchContactInput {\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0;\n    width: 100%;\n    border-radius: 8px;\n    padding: 6px;\n    border: none;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    background-color: var(--f4-background);\n    outline: none;\n  }\n}\n\n\n.contactContent{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  >div{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  img{\n    min-width: 20px;\n    height: 20px;\n    border-radius: 999px;\n  }\n\n  .contactInfo{\n    display: flex;\n    flex-direction: column;\n    p{\n      margin: 0;\n      color: #09090B;\n      font-size: 16px;\n    }\n    span{\n      color: #666666;\n      font-size: 13px;\n    }\n    >div{\n      display: flex;\n      align-items: center;\n      gap: 5px;\n    }\n  }\n}\n.chevronIcon {\n  margin-top: 1px;\n  margin-left: auto;\n  color: var(--_292d32-color);\n}\n\n\n.urlContainer{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n\n\n.formulaContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  p{\n    margin: 0;\n  }\n  span{\n    color: #717171;\n    font-size: 13px;\n  }\n  input{\n    width: 100%;\n  }\n}\n\n\n\n.assessmentContainer{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  .assessmentContent{\n    display: flex;\n    align-items: center;\n    gap: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_oF2Lt`,
	"CreateParameterPopup": `CreateParameterPopup_c2BBQ`,
	"CreateParameterPopupContent": `CreateParameterPopupContent_jTRlZ`,
	"contentContiner": `contentContiner_IJO8f`,
	"contentParameter": `contentParameter_Ut9DT`,
	"textContent": `textContent_W0faP`,
	"unitMeasure": `unitMeasure_gv2iG`,
	"leftSide": `leftSide_vl7xj`,
	"categoryParameter": `categoryParameter_I4dmC`,
	"rightSideCategoryParameter": `rightSideCategoryParameter_QCDdh`,
	"row": `row_pnSrH`,
	"numberComponent": `numberComponent_nxCxX`,
	"rightSideType": `rightSideType_muB9d`,
	"numberComponentColumn": `numberComponentColumn_jfbOT`,
	"amountContainer": `amountContainer_btk60`,
	"discountContainer": `discountContainer_SG7W1`,
	"dateContainer": `dateContainer_hMAij`,
	"selectCurrencyBtn": `selectCurrencyBtn_FE4O4`,
	"chevronIcon": `chevronIcon__Bdpx`,
	"bgCurrency": `bgCurrency_DK_Ts`,
	"newCurrencyPopup": `newCurrencyPopup_vfNw6`,
	"dropdownOption": `dropdownOption_B8mYT`,
	"discountTypeButtons": `discountTypeButtons_lX44y`,
	"activeButton": `activeButton_ZIr2C`,
	"dateRanges": `dateRanges_crDDL`,
	"filesContainer": `filesContainer_YGx0m`,
	"SortableItemList": `SortableItemList_wYfqJ`,
	"GrabIconContainer": `GrabIconContainer_XuJrK`,
	"categoriesContainer": `categoriesContainer_EWMp1`,
	"listItemContainer": `listItemContainer_OvM8v`,
	"valuesContent": `valuesContent_zzw0M`,
	"ColorListItem": `ColorListItem_v7S7e`,
	"tagsContainer": `tagsContainer_J3raB`,
	"tag": `tag_F5Ev1`,
	"circle": `circle_pACdz`,
	"actionsTag": `actionsTag_m14LW`,
	"dropdownContainer": `dropdownContainer_aFmBv`,
	"statusContent": `statusContent_k5zIT`,
	"infoStatus": `infoStatus_evGxL`,
	"paid": `paid_RIqDr`,
	"statusPopup": `statusPopup_lOGBB`,
	"statusOptionSelected": `statusOptionSelected_DSixX`,
	"checklistItem": `checklistItem_XD3O_`,
	"checklistInfo": `checklistInfo_Ix7lV`,
	"inputParameter": `inputParameter_ft7Nd`,
	"inputContainer": `inputContainer_miM1Q`,
	"searchContactInput": `searchContactInput_TufCi`,
	"contactContent": `contactContent_QpBRr`,
	"contactInfo": `contactInfo_wOhUM`,
	"urlContainer": `urlContainer_XpqoW`,
	"formulaContainer": `formulaContainer_JFBX6`,
	"assessmentContainer": `assessmentContainer_VJCwp`,
	"assessmentContent": `assessmentContent_gGfmU`
};
export default ___CSS_LOADER_EXPORT___;
